import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-e630a51e")
const _hoisted_1 = { id: "label-sizes-btn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "label-option-desc" }, "SIZE", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", { class: "caret" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        id: "size-info",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showLabelSizes && _ctx.showLabelSizes(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.currentLabel.title) + " ", 1),
        _hoisted_3
      ])
    ])
  ]))
}